<template>
    <form class="form-control-line m-t-40" @submit.prevent="onSubmit">
        <div class="card text-white bg-danger" v-if="errors">
            <div class="card-header">
                <h4 class="m-b-0 text-white">Validation Errors</h4></div>
            <div class="card-body">
                <p v-if="typeof errors === 'string'" class="card-text">{{errors}}</p>
                <p v-else class="card-text" v-for="(error, key) in errors" :key="key">
                    {{key}}: {{error}}
                </p>
            </div>
        </div>
        <div class="form-group">
            <label for="domain">Domain<br>
                <i>
                    <b>example: </b>
                </i>
                <span>vr-dev.team</span>
            </label>
            <input type="text" name="domain" id="domain" v-model.trim="domain"
                   class="form-control form-control-line">
            <div v-if="$v.domain.$error">
                <div class="text-danger" v-if="!$v.domain.required">Domain name is required.</div>
            </div>
        </div>
        <div class="form-actions">
            <button type="submit" class="btn btn-info btn-rounded text-uppercase waves-effect waves-light m-r-5"
                    v-show="!loadingStatus">
                Save
            </button>
            <button class="btn btn-success btn-rounded text-uppercase waves-effect waves-light m-r-5" type="button"
                    disabled v-show="loadingStatus">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                Loading...
            </button>
            <router-link to="/spam-domains" class="btn btn-success btn-rounded text-uppercase waves-effect waves-light">
                Back
            </router-link>
        </div>
    </form>
</template>

<script>
    import { required } from 'vuelidate/src/validators';
    import SpamDomainService from '../../services/SpamDomainService';

    export default {
        name: 'SpamDomainForm',
        data() {
            return {
                domain: '',
                loadingStatus: false,
                errors: ''
            }
        },
        validations: {
            domain: {required},
        },
        mounted() {
            if (this.$route.params.id) {
                SpamDomainService.getSpamDomain(this.$route.params.id).then(response => {
                    this.domain = response.data.domain;
                    this.$emit('hidePreloader', true)
                });
            }
        },
        methods: {
            onSubmit() {
                this.$v.$touch();
                if (this.$v.$invalid) return;
                this.loadingStatus = true;
                let submitMethod = null;
                if (this.$route.params.id) {
                    submitMethod = SpamDomainService.updateSpamDomain(this.$route.params.id, this.domain);
                } else {
                    submitMethod = SpamDomainService.addSpamDomain(this.domain);
                }

                submitMethod.then(response => {
                    if (response.data.error !== undefined) {
                        this.errors = response.data.error;
                    } else {
                        switch (response.status) {
                            case 201:
                                this.$snotify.success('Domain ' + response.data.domainId + ' added successfully!', 'Success!!!');
                                this.$router.push({name: 'spamDomains'});
                                break;
                            case 200:
                                this.$snotify.success('Domain ' + response.data.domainId + ' updated successfully!', 'Success!!!');
                                this.$router.push({name: 'spamDomains'});
                                break;
                        }
                    }
                    this.loadingStatus = false;
                });
            }
        }
    }
</script>

<style scoped>

</style>